<template>
  <div id="ultra-frame" :style="`background-color:${bg}`">
    <div id="ultra-container">
      <SubpageHeader
        :is_sticky="true"
        :background_color="bg"
        :foreground_color="fg"
        @backBtnClicked="test()"
      />
      <ContactPageContactList
        :roles="roles"
        :company="company"
        :has_lines="false"
        :background_color="bg"
        :foreground_color="fg"
      />
    </div>
  </div>
</template>

<script>
import ContactPageContactList from '@/modules/WorkPackageWIP/ContactPageContactList.module.vue';
import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';

  export default {
    components: {
      ContactPageContactList,
      SubpageHeader,
    },

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',

      is_edit: true,

      roles: [
        {
          name: 'Craftsman',
          persons: [
            { id: 0, name: 'Thomas Lokonotif', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260' },
            { id: 1, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 2, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 3, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 4, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 5, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 6, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 7, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 8, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 9, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 10, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 11, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 12, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 13, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 14, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 15, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 16, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 17, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 18, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 19, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 20, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 21, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 22, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 23, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 24, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 25, name: 'Oscar Machblats', has_phone: false, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 26, name: 'Oscar Machblats', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
          ],
        },
        {
          name: 'Owner',
          persons: [
            { id: 27, name: 'Ignatius von und zu Steinstein', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/937481/pexels-photo-937481.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
            { id: 28, name: 'Sickgnatius McSmash', has_phone: true, has_email: true, image: 'https://images.pexels.com/photos/937481/pexels-photo-937481.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260' },
          ],
        },
      ],

      company: {
        image: 'https://i.epvpimg.com/fXaQfab.jpg',
        name: 'Firminima GmbH',
        address: {
          zip_code: '76133',
          city: 'Karlsruhe',
          street: 'Einestraße',
          house_nr: '42',
          additional_info: '',
        },
        mail: 'firminima@hello.moe',
        phone_nr: '+49 173 252435',
      }
    }),

    methods: {

    },
  }
</script>

<style>
  #ultra-frame {
    width: 100%;
    height: calc(100% - 48px) !important;
  }
  #ultra-container {
    margin: 10px;
    margin-top: 0;
  }
</style>
